import { useEffect, useRef, useState } from "react";

const AutoShrinkText = ({ text, minScale = 0.1, maxFontSize = 32 }) => {
  const ref = useRef(null);
  
  const [fontSize, setFontSize] = useState(maxFontSize);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const parentWidth = 238;

    let currentSize = maxFontSize;
    el.style.fontSize = currentSize + "px";

    while (el.scrollWidth > parentWidth && currentSize > maxFontSize * minScale) {
      currentSize -= 1;
      el.style.fontSize = currentSize + "px";
    }

    setFontSize(currentSize);
  }, [text, minScale, maxFontSize]);

  return (
    <div
      ref={ref}
      style={{
        fontSize: fontSize,
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
    >
      {text}
    </div>
  );
};

export const AutoShrinkTextPlaceholder = ({ texts, minScale = 0.1, maxFontSize = 32 }) => {

  const ref = useRef(null);
  const [fontSize, setFontSize] = useState(maxFontSize);

  const [typed, setTyped] = useState("");
  const [textIndex, setTextIndex] = useState(0);

  const typingSpeed = 100;
  const pauseDuration = 2000;
  const clearDuration = 300;

  useEffect(() => {
    if (!texts?.length) return;

    const currentText = texts[textIndex];
    let charIndex = 0;
    let timeoutId;

    const typeNextChar = () => {
      if (charIndex <= currentText.length) {
        setTyped(currentText.slice(0, charIndex));
        charIndex += 1;
        timeoutId = setTimeout(typeNextChar, typingSpeed);
      } else {
        timeoutId = setTimeout(() => {
          setTyped("");

          timeoutId = setTimeout(() => {
            setTextIndex((prev) => (prev + 1) % texts.length);
          }, clearDuration);
        }, pauseDuration);
      }
    };

    timeoutId = setTimeout(() => {
      typeNextChar();
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [texts, textIndex]);


  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const parentWidth = 238;

    let currentSize = maxFontSize;
    el.style.fontSize = currentSize + "px";

    while (el.scrollWidth > parentWidth && currentSize > maxFontSize * minScale) {
      currentSize -= 1;
      el.style.fontSize = currentSize + "px";
    }

    setFontSize(currentSize);
  }, [typed, minScale, maxFontSize]);

  return (
    <div
      ref={ref}
      style={{
        fontSize: fontSize,
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
    >
      {typed}
    </div>
  );
};

export default AutoShrinkText;